import { getApiReducer } from "redux-store/api-sagas";

import {
  LOAD_DELETED_DEVICES_FAILURE,
  LOAD_DELETED_DEVICES_SUCCESS,
} from "./actions";

const deletedDeviceReducer = getApiReducer(
  LOAD_DELETED_DEVICES_SUCCESS,
  LOAD_DELETED_DEVICES_FAILURE,
);

export { deletedDeviceReducer };
